export const TeamRouting = [
    {
      path: "/project/team/list",
      name: "project-team-list",
      meta: { title: "项目团队" },
      notice: { type: "project_examine", hasNotice: false },
      component: () =>
        import(
          /* webpackChunkName: "project-profile" */ "@/views/project/team/list/index.vue"),
    }
    
  ];
  